import { pageNumberState } from "@/atoms/order/page-number-state";
import { ButtonColor } from "@/common/enum/button-color";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { Button, Pagination, Table } from "flowbite-react";
import React from "react";
import { useSetRecoilState } from "recoil";
import { ErpDataDto } from "../../../types/dto/erp-data-dto";

interface Props {
  headersLength: number;
  itemPage: BasePageDto<ErpDataDto>;
  handlePageChange: (currentPage: number) => void;
  setErpCode: () => void;
}

export const ItemCodeTableFooter: React.FC<Props> = ({
  headersLength,
  itemPage,
  handlePageChange,
  setErpCode,
}) => {
  const setPageNumber = useSetRecoilState(pageNumberState);
  return (
    <Table.Row className="bg-white">
      <Table.Cell colSpan={headersLength}>
        <div className="flex justify-between items-center">
          <div className="px-[16px]">
            <Button
              size="sm"
              color={ButtonColor.TRANSPARENT_OUTLINE}
              onClick={setErpCode}
            >
              선택 완료
            </Button>
          </div>
          <Pagination
            currentPage={itemPage.currentPage}
            totalPages={itemPage.totalPage}
            onPageChange={handlePageChange}
            nextLabel=""
            previousLabel=""
            showIcons
          />
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
